import { Outlet, useNavigate, useParams } from 'react-router';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Button } from '@material-tailwind/react';
import { SessionListItem } from '../../../components/sessions/SessionListItem';
import { useStore } from '../../../store/store';
import { ActionPane } from '../../../components/developer/ActionPane';
import { SessionPane } from '../../../components/developer/SessionPane';
import { WebsocketPane } from '../../../components/developer/WebsocketPane';
import { UserPane } from '../../../components/developer/UserPane';
import { ActiveSessionPane } from '../../../components/developer/ActiveSessionPane';
import { StoredRelatedUser } from '../../../components/developer/StoredRelatedUser';
import SelectInput from '../../../components/inputs/SelectInput';
import SuccessButton from '../../../components/buttons/SuccessButton';

const ConsolePage = observer(() => {
  const store = useStore();
  const navigate = useNavigate();
  const [chosedStore, setStore] = useState('0');
  const getStore = () => {
    switch (chosedStore) {
      case '0':
        return store;
      case '1':
        return store.user;
      case '2':
        return store.friends;
      case '3':
        return store.language;
      case '4':
        return store.sessions;
      case '5':
        return store.socket;
      case '6':
        return store.theme;
      case '7':
        return store.channels;
      case '8':
        return store.e2ee;
    }
  };
  if (!store) return;
  return (
    <>
      <section className={'w-full h-full mb-10 space-y-10'}>
        <div className={'flex flex-row justify-between mx-4'}>
          <SelectInput
            label="Select Logs"
            className={'w-3/6'}
            value={chosedStore}
            onChange={event => {
              setStore(event);
            }}
            options={[
              { value: '0', label: 'Store' },
              { value: '1', label: 'UserStore' },
              { value: '2', label: 'FriendStore' },
              { value: '3', label: 'LanguageStore' },
              { value: '4', label: 'SessionStore' },
              { value: '5', label: 'SocketStore' },
              { value: '6', label: 'ThemeStore' },
              { value: '7', label: 'ChannelStore' },
              { value: '8', label: 'E2EEStore' },
            ]}
          />
          <SuccessButton
            className={'w-1/6'}
            onClick={() => {
              getStore()._downloadLogs();
            }}
            children={'Pobierz logi'}
          />
        </div>
        <div className={'rounded-xl bg-black p-2 w-full whitespace-pre-wrap overflow-auto h-5/6'}>
          {getStore().logs.map(log => (
            <pre className={'bg-transparent -my-2'}>{log}</pre>
          ))}
        </div>
      </section>
    </>
  );
});

export default ConsolePage;
